import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Header from '../../Header';
import Banner from '../Banner';
import Footer from '../../Footer';

const CheckIcon = () => (
  <svg className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
  </svg>
);

const c = {
  tr: {
    bannerTitle: 'UyumTakip — MASAK Uyum ve Müşteri Yönetim Platformu',
    bannerDesc: 'Müşteri tanımadan yaptırım sorgulamaya, evrak takibinden raporlamaya kadar tüm uyum süreçlerinizi tek yazılımda toplayın. Manuel işi azaltın, hatayı düşürün, denetime her an hazır olun.',
    home: 'Ana Sayfa',
    services: 'Hizmetlerimiz',
    demo: 'Demo Talep Et',
    contact: 'Bize Ulaşın',
    whatTitle: 'UyumTakip nedir?',
    whatText: 'UyumTakip; kuyumculuk, döviz ve kıymetli maden, emlak, finans ve benzeri yükümlü sektörler için geliştirilmiş bulut tabanlı bir uyum yönetim yazılımıdır. 5549 sayılı Kanun ve MASAK düzenlemeleri kapsamındaki müşteri tanıma, risk değerlendirme, işlem izleme ve kayıt/belge saklama yükümlülüklerini tek bir merkezde, izlenebilir ve denetlenebilir şekilde yönetmenizi sağlar. Her kurum kendi verisiyle izole çalışır; süreçler otomatikleşir, uyum ekibinizin yükü hafifler.',
    whoTitle: 'Kimler için?',
    who: [
      'Kuyumcu, sarraf, kıymetli maden ve taş alım-satımı yapanlar',
      'Döviz büroları ve finansal hizmet sağlayıcılar',
      'Emlak ve gayrimenkul firmaları',
      'MASAK yükümlülüğü bulunan diğer işletmeler',
    ],
    featuresTitle: 'Öne Çıkan Özellikler',
    features: [
      { t: 'Müşteri Tanıma (KYC)', d: 'Bireysel ve kurumsal müşteri kayıtları, yetkili kişiler, kimlik ve iletişim bilgileri tek profilde.' },
      { t: 'AML / MASAK / Yaptırım Sorgulama', d: 'Müşteri ve yetkilileri MASAK, OFAC ve yaptırım listelerinde tarayın; sonuçları kanıtlı biçimde saklayın.' },
      { t: 'Risk Yönetimi', d: 'Risk listeleri (gri/kara/beyaz), sektör bazlı risk ve AML durumu ile müşterilerinizi sınıflandırın.' },
      { t: 'Evrak Yönetimi', d: 'Belge yükleme, süre takibi, eksik evrak uyarıları ve arşivleme; yüklenen belgeler sıkıştırılarak güvenle saklanır.' },
      { t: 'İşlem Takibi', d: 'İşlemleri kaydedin, onay akışıyla yönetin, müşteri bazında hacmi izleyin.' },
      { t: 'Banka & Muhasebe Entegrasyonu', d: 'Banka hareketleri ve muhasebe (Mikro) verileriyle otomatik eşleştirme ve mutabakat.' },
      { t: 'Online Hesap Açılışı', d: 'Müşteriye kişiye özel davet linki gönderin; bilgi ve evraklarını uzaktan girsin, başvuru onayınıza düşsün.' },
      { t: 'Dinamik Raporlama', d: 'İhtiyacınıza göre rapor oluşturun; tablo, grafik ve dışa aktarma (Excel/PDF) ile karar alın.' },
      { t: 'Denetim İzi', d: 'Kim, ne zaman, hangi işlemi yaptı — tüm kritik hareketler kayıt altında.' },
    ],
    whyTitle: 'Neden UyumTakip?',
    why: [
      { t: 'Tek platform', d: 'Dağınık Excel ve evraklar yerine merkezi, izlenebilir bir sistem.' },
      { t: 'Otomasyon', d: 'Sorgulama, takip ve raporlamada manuel işi azaltır.' },
      { t: 'Denetime hazır', d: 'Yükümlülükleriniz eksiksiz kayıt altında, her an raporlanabilir.' },
      { t: 'Esnek ve ölçeklenebilir', d: 'Kurumunuzun büyüklüğüne ve sektörüne uyar.' },
      { t: 'Güvenli', d: 'Kurumsal veri izolasyonu ve yetki bazlı erişim.' },
    ],
    ctaTitle: 'Uyum süreçlerinizi bugün sadeleştirin.',
    ctaText: "UyumTakip'in kurumunuza nasıl değer katacağını görmek için kısa bir demo planlayalım.",
    demoSubject: 'UyumTakip Demo Talebi',
  },
  en: {
    bannerTitle: 'UyumTakip — MASAK Compliance & Customer Management Platform',
    bannerDesc: 'Bring all your compliance processes — from customer onboarding and sanctions screening to document tracking and reporting — into a single software. Reduce manual work, cut errors and stay audit-ready at all times.',
    home: 'Home',
    services: 'Our Services',
    demo: 'Request Demo',
    contact: 'Contact Us',
    whatTitle: 'What is UyumTakip?',
    whatText: 'UyumTakip is a cloud-based compliance management software developed for obliged sectors such as jewelry, currency and precious metals, real estate and finance. It lets you manage customer onboarding, risk assessment, transaction monitoring and record/document retention obligations under Law No. 5549 and MASAK regulations in a single, traceable and auditable center. Each organization operates in isolation with its own data; processes are automated and the burden on your compliance team is reduced.',
    whoTitle: 'Who is it for?',
    who: [
      'Jewelers, bullion dealers and precious metals & stones traders',
      'Currency exchange offices and financial service providers',
      'Real estate firms',
      'Other businesses with MASAK obligations',
    ],
    featuresTitle: 'Key Features',
    features: [
      { t: 'Customer Onboarding (KYC)', d: 'Individual and corporate customer records, authorized persons, identity and contact details in a single profile.' },
      { t: 'AML / MASAK / Sanctions Screening', d: 'Screen customers and their representatives against MASAK, OFAC and sanctions lists; store the results with evidence.' },
      { t: 'Risk Management', d: 'Classify your customers with risk lists (grey/black/white), sector-based risk and AML status.' },
      { t: 'Document Management', d: 'Document upload, expiry tracking, missing-document alerts and archiving; uploaded files are compressed and stored securely.' },
      { t: 'Transaction Tracking', d: 'Record transactions, manage them with an approval flow, and monitor volume per customer.' },
      { t: 'Bank & Accounting Integration', d: 'Automatic matching and reconciliation with bank movements and accounting (Mikro) data.' },
      { t: 'Online Account Opening', d: 'Send customers a personalized invitation link; they submit their details and documents remotely, landing for your approval.' },
      { t: 'Dynamic Reporting', d: 'Build reports as needed; make decisions with tables, charts and export (Excel/PDF).' },
      { t: 'Audit Trail', d: 'Who did what and when — all critical actions are logged.' },
    ],
    whyTitle: 'Why UyumTakip?',
    why: [
      { t: 'Single platform', d: 'A central, traceable system instead of scattered Excel files and documents.' },
      { t: 'Automation', d: 'Reduces manual work in screening, tracking and reporting.' },
      { t: 'Audit-ready', d: 'Your obligations are fully recorded and reportable at any time.' },
      { t: 'Flexible & scalable', d: "Adapts to your organization's size and sector." },
      { t: 'Secure', d: 'Corporate data isolation and role-based access.' },
    ],
    ctaTitle: 'Simplify your compliance processes today.',
    ctaText: "Let's schedule a short demo to see how UyumTakip can add value to your organization.",
    demoSubject: 'UyumTakip Demo Request',
  },
};

const WebApplications: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const lang: 'en' | 'tr' = location.pathname.startsWith('/en') ? 'en' : 'tr';
  const t = c[lang];

  const setLanguage = (newLang: 'en' | 'tr') => {
    let newPath = location.pathname;
    if (newLang === 'en' && !newPath.startsWith('/en')) {
      newPath = '/en' + (newPath.startsWith('/tr') ? newPath.slice(3) : newPath);
    } else if (newLang === 'tr' && !newPath.startsWith('/tr')) {
      newPath = '/tr' + (newPath.startsWith('/en') ? newPath.slice(3) : newPath);
    }
    navigate(newPath + location.search, { replace: true });
  };

  const breadcrumb = (
    <div className="mt-1 mb-2 text-sm flex items-center space-x-2">
      <Link to={`/${lang}`} className="text-gray-400 font-bold">{t.home}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <Link to={`/${lang}/investments`} className="text-gray-400 font-bold">{t.services}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <span className="text-white font-bold">UyumTakip</span>
    </div>
  );

  return (
    <div>
      <Header language={lang} setLanguage={setLanguage} />
      <Banner
        title={t.bannerTitle}
        description={t.bannerDesc}
        image={process.env.PUBLIC_URL + '/banner.png'}
        breadcrumb={breadcrumb}
      />

      {/* Logo + CTA */}
      <section className="bg-white py-12">
        <div className="max-w-5xl mx-auto px-4 flex flex-col items-center text-center">
          <div className="bg-gradient-to-br from-yellow-50 via-white to-gray-50 rounded-2xl px-10 py-8 shadow-sm border border-gray-100 mb-8">
            <img
              src={process.env.PUBLIC_URL + '/uyumtakip-logo.png'}
              alt="UyumTakip"
              className="h-16 w-auto object-contain"
            />
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={`mailto:info@cgteknoloji.com?subject=${encodeURIComponent(t.demoSubject)}`}
              className="px-6 py-3 bg-red-600 text-white font-semibold rounded-lg shadow hover:bg-red-700 transition-colors"
            >
              {t.demo}
            </a>
            <Link
              to={`/${lang}?scroll=contact`}
              className="px-6 py-3 bg-white text-red-600 font-semibold rounded-lg border-2 border-red-600 hover:bg-red-50 transition-colors"
            >
              {t.contact}
            </Link>
          </div>

          {/* UyumTakip bağlantıları */}
          <div className="flex flex-wrap justify-center items-center gap-6 mt-8">
            <a
              href="https://uyumtakip.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-gray-600 hover:text-red-600 transition-colors font-medium"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.6 9h16.8M3.6 15h16.8M12 3a15 15 0 010 18 15 15 0 010-18z" /></svg>
              uyumtakip.com
            </a>
            <a
              href="https://www.instagram.com/uyum.takip/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-red-600 transition-colors"
              aria-label="Instagram"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            </a>
            <a
              href="https://www.linkedin.com/company/uyum-takip/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-red-600 transition-colors"
              aria-label="LinkedIn"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
            </a>
          </div>
        </div>
      </section>

      {/* UyumTakip nedir? */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">{t.whatTitle}</h2>
          <p className="text-lg text-gray-700 leading-relaxed" style={{ textAlign: 'justify' }}>{t.whatText}</p>
        </div>
      </section>

      {/* Kimler için? */}
      <section className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">{t.whoTitle}</h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {t.who.map((item) => (
              <li key={item} className="flex items-start gap-3 bg-gray-50 rounded-lg p-4">
                <CheckIcon />
                <span className="text-gray-700">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Öne çıkan özellikler */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center">{t.featuresTitle}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {t.features.map((f) => (
              <div key={f.t} className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-lg transition-shadow">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 rounded-lg bg-red-600 flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">{f.t}</h3>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">{f.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Neden UyumTakip? */}
      <section className="bg-white py-16">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center">{t.whyTitle}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {t.why.map((item) => (
              <div key={item.t} className="flex items-start gap-3">
                <CheckIcon />
                <div>
                  <h3 className="font-bold text-gray-900">{item.t}</h3>
                  <p className="text-gray-600 text-sm">{item.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-white py-16">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">{t.ctaTitle}</h2>
          <p className="text-lg text-gray-600 mb-8">{t.ctaText}</p>
          <a
            href={`mailto:info@cgteknoloji.com?subject=${encodeURIComponent(t.demoSubject)}`}
            className="inline-block px-8 py-3 bg-red-600 text-white font-semibold rounded-lg shadow hover:bg-red-700 transition-colors"
          >
            {t.demo}
          </a>
        </div>
      </section>

      <Footer language={lang} />
    </div>
  );
};

export default WebApplications;
